<div class="dialog-header">
  <h3 matDialogTitle style="font-size: large; font-weight: 200">
    {{ nodeInfoModalTitle }}
  </h3>
  <button
    class="close-button"
    bciprimarybutton
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div
    style="height: 500px; max-height: 500px; width: 100%; overflow-y: scroll"
  >
    <form
      [formGroup]="formData"
      #formDirective="ngForm"
      novalidate
      style="width: 97%"
    >
      <div class="row">
        <div class="col-md-1">
          <mat-radio-button
            #nodeType
            class="label-input"
            [value]="getnodeType().TEXT"
            (change)="changeNodeType($event)"
            [checked]="modalForm.nodeType === constant_TEXT"
            [disabled]="radioNodeNameIsDisabled"
          ></mat-radio-button>
        </div>
        <div class="col-md-4">
          <mat-label class="label-input">Node name</mat-label>
        </div>

        <div class="col-md-7">
          <mat-form-field>
            <input
              matInput
              formControlName="nodeTitleCtr"
              [(ngModel)]="modalForm.nodeTitle"
              [readonly]="modalForm.nodeType !== constant_TEXT"
            />
          </mat-form-field>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          ((modalForm.nodeData && modalForm.nodeData.id) === 0 ||
            dashboardNameInputEnabled) &&
          selectedTreeType === treeType.GENERIC_TREE
        "
      >
        <div class="col-md-1">
          <mat-radio-button
            #nodeType
            class="label-input"
            value="{{ getnodeType().TEXT }}"
            (change)="changeNodeType($event)"
          ></mat-radio-button>
        </div>
        <div class="col-md-4">
          <mat-label class="label-input">Dashboard name</mat-label>
        </div>

        <div class="col-md-7">
          <mat-form-field>
            <input
              matInput
              formControlName="dashboardTitleCtr"
              [(ngModel)]="modalForm.dashboardTitle"
              [readonly]="modalForm.nodeType !== constant_TEXT"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-1">
          <mat-radio-button
            #nodeType
            class="label-input"
            value="{{ getnodeType().PROCESS }}"
            (change)="changeNodeType($event)"
            [checked]="modalForm.nodeType === constant_PROCESS"
          ></mat-radio-button>
        </div>
        <div class="col-md-4">
          <mat-label class="label-input">Assign Process And Loads</mat-label>
        </div>
        <div class="col-md-7">
          <mat-form-field>
            <mat-label>Select Process</mat-label>
            <mat-select
              [(ngModel)]="modalForm.selectedProcess"
              formControlName="processCtr"
              placeholder="Select Meter"
              required
              [disabled]="modalForm.nodeType !== constant_PROCESS"
              (selectionChange)="selectMeter()"
            >
              <mat-option
                *ngFor="let processe of processes"
                [value]="processe"
                >{{ processe.name }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          selectedTreeType === treeType.LOAD_ON_TREE ||
          selectedTreeType === treeType.INVERTER_TREE ||
          selectedTreeType === treeType.GENERIC_TREE
        "
      >
        <div class="col-md-1">
          <mat-checkbox
            class="label-input"
            formControlName="showInVerticalCtr"
            [(ngModel)]="modalForm.showInVertical"
          >
          </mat-checkbox>
        </div>
        <div class="col-md-11">
          <mat-label class="label-input">Show in vertical mode</mat-label>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          selectedTreeType === treeType.INVERTER_TREE ||
          selectedTreeType === treeType.GENERIC_TREE
        "
      >
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <mat-label class="label-input">Node image</mat-label>
        </div>
        <div class="col-md-7">
          <div class="row">
            <div class="col-md-12">
              <!-- TreeNodeImage -->
              <input
                type="file"
                id="uploadNodeImage"
                (change)="uploadDocument($event, constant_TREE_NODE_IMAGE)"
                class="hidden"
                accept=".jpeg,.jpg,.png,.jpe,image/jpeg,image/png"
              />
              <button
                type="button"
                id="upload-image"
                (cdkAutofill)="selectDocument('uploadNodeImage')"
                matTooltip="Select node picture"
                style="margin-top: 1em"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="edit icon"
                    class="bosch-ic-paperclip"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
            </div>
          </div>
          <div class="row">
            <div *ngIf="uploadedFile !== undefined" class="col-md-10">
              {{ uploadedFile.name }}
            </div>
            <div class="col-md-2">
              <button
                class="button-primary"
                (click)="removeNodeImage()"
                title="Remove node picture"
                *ngIf="uploadedFile !== undefined"
              >
                <span>
                  <mat-icon
                    aria-hidden="false"
                    aria-label="edit icon"
                    class="bosch-ic-delete"
                    style="width: max-content"
                  ></mat-icon>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        *ngIf="
          selectedTreeType === treeType.GENERIC_TREE ||
          (selectedTreeType === treeType.INVERTER_TREE &&
            modalForm.selectedMeter !== undefined)
        "
      >
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <mat-label class="label-input">Parameters</mat-label>
        </div>
      </div>

      <div
        class="row"
        *ngIf="
          selectedTreeType === treeType.GENERIC_TREE ||
          (selectedTreeType === treeType.INVERTER_TREE &&
            modalForm.selectedMeter !== undefined)
        "
      >
        <div
          class="span2"
          *ngFor="
            let param of modalForm.selectedLoadParameters;
            let $index = index
          "
        >
          <div class="col-md-6" *ngIf="modalForm.parameters.length > 0">
            <mat-checkbox
              [checked]="modalForm.parameters[$index].parameterName !== ''"
              (click)="changeParam(param.text, $index)"
            >
              {{ param.text }}</mat-checkbox
            >

            <div
              *ngIf="
                modalForm.parameters.length > 0 &&
                modalForm.parameters[$index].parameterName !== '' &&
                modalForm.parameters[$index].parameterName.length > 0
              "
            >
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-4">
                  <mat-label class="label-input">Display Name : </mat-label>
                </div>
                <div class="col-md-5">
                  <mat-form-field>
                    <input
                      matInput
                      type="text"
                      formControlName="paramNameCtr{{
                        formControlIndex[$index]
                      }}"
                      [(ngModel)]="modalForm.parameters[$index].displayName"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-4">
                  <mat-label class="label-input">Condition Operator</mat-label>
                </div>
                <div class="col-md-5">
                  <mat-form-field>
                    <mat-select
                      formControlName="paramConditionOperatorCtr{{
                        formControlIndex[$index]
                      }}"
                      [(ngModel)]="
                        modalForm.parameters[$index].conditionOperator
                      "
                    >
                      <mat-option value="" disabled
                        >Select Operator
                      </mat-option>
                      <mat-option value="=">Equal to</mat-option>
                      <mat-option value="!=">Not Equal to</mat-option>
                      <mat-option value=">">Greater Than</mat-option>
                      <mat-option value="<">Less Than</mat-option>
                      <mat-option value=">="
                        >Greater Than or equal to</mat-option
                      >
                      <mat-option value="<=">Less Than or equal to</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-4">
                  <mat-label class="label-input">Condition Value: </mat-label>
                </div>
                <div class="col-md-5">
                  <input
                    type="number"
                    formControlName="paramConditionValueCtr{{
                      formControlIndex[$index]
                    }}"
                    [(ngModel)]="modalForm.parameters[$index].conditionValue"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-4">
                  <mat-label class="label-input">Value Source: </mat-label>
                </div>
                <div class="col-md-5">
                  <mat-form-field>
                    <mat-select
                      formControlName="paramValueSourceCtr{{
                        formControlIndex[$index]
                      }}"
                      [(ngModel)]="modalForm.parameters[$index].valueSource"
                    >
                      <mat-option value="sumOfChildNode"
                        >Sum of Child Nodes</mat-option
                      >
                      <mat-option
                        value="NodeMeterReading"
                        [disabled]="modalForm.nodeType !== nodeType.METER"
                        >Based on Node's reading</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1"></div>
                <div class="col-md-4">
                  <mat-label class="label-input">Node Color: </mat-label>
                </div>
                <div class="col-md-5">
                  <mat-form-field>
                    <mat-select
                      formControlName="paramNodeColorCtr{{
                        formControlIndex[$index]
                      }}"
                      [(ngModel)]="modalForm.parameters[$index].nodeColor"
                    >
                      <mat-option value="colorBlue">Blue</mat-option>
                      <mat-option value="colorYellow">Yellow</mat-option>
                      <mat-option value="colorRed">Red</mat-option>
                      <mat-option value="colorGreen">Green</mat-option>
                      <mat-option value="GTE_colorRed_LT_colorYellow"
                        >Condition Satisfied : RED, else : YELLOW</mat-option
                      >
                      <mat-option value="GTE_colorGreen_LT_colorRed"
                        >Condition Satisfied : GREEN , else : RED</mat-option
                      >
                      <mat-option value="GTE_colorBlue_LT_colorRed"
                        >Condition Satisfied : BLUE , else : RED</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <button
    type="button"
    class="button-primary pull-right alignClose"
    (click)="close(false)"
  >
    Cancel
  </button>
  <button
    type="button"
    class="button-primary pull-right alignClose"
    (click)="saveNode()"
  >
    OK
  </button>
</mat-dialog-footer>
